/**
 * @file 慧播电商数字人平台
 * @author putianyi
 */

import React, {useState, useEffect, lazy, Suspense} from 'react';
import {Redirect, Switch, Route} from 'react-router-dom';
import cls from 'classnames';
import moment from 'moment';
import {Popover, Spin, notification, message, Form, Button} from 'antd';
import {observer} from 'mobx-react';
import {get, partial, includes} from 'lodash';
import {useInterval} from '../../../../utils/extHooks';
import parseUrl from '../../../../utils/parseUrl';
import {getStorage, setStorage} from '../../../../utils/storage';
import {FAQ_UPDATE_POPOVER, QUERY_PROGRESS_TYPE, NOTICE_POP_SHOW_DATE} from '../../config';
import {getUserInfo, getMediaSelectInfo, getNoticePopList, getNoticeCarouselList, readNotice, saveMediaInfo,
    getAgreementContent, agreementAction, confirmAgreement, confirmAnchorMakerAgreement, anchorMakerAgreementResult,
    getAvailablePort, getPluginVersion, initPlugin} from '../../services';
import {aiimgClickEntryLog, efficiencyLog, productLibraryLog, scripListLog, infoBannerLog, learnCenterLog, webVisitLog, aiScriptToolLog} from '../../log/ubcLog';
import {useStore} from '../../stores';
import logo from '../../assets/images/logo.png';
import iconClose from '../../assets/images/icon_close_banner.png';
import iconClose2 from '../../assets/images/icon_close2.png';
import iconArrActive from '../../assets/images/icon_navigation_arr_active.png';
import iconArrDefault from '../../assets/images/icon_navigation_arr_default.png';
import iconPlaying from '../../assets/images/playing_blue.gif';
import './index.less';
import globalLoading from '../../assets/images/global_loading.gif';
import {Modal} from '../../../../components/antd';
import {uploadMulti} from '../../utils/videoUploader';
import AIGCImage from './AIGCImage';
import AIGCScriptTool from './AIGCScriptTool';
import ExternalLive from './ExternalLive';
import ExternalLivePage from './ExternalLive/livePage';
import WeirwoodErrorBoundary from './ErrorBoundary';
import MediaModaContent from './Home/MediaModal';
import ExternalAuthModal from './ExternalAuthModal';

const Home = lazy(() => import('./Home'));
const DigitalHome = lazy(() => import('./DigitalAnchor'));
const DigitalCharacter = lazy(() => import('./DigitalAnchor/CharacterList'));
const Interact = lazy(() => import('./DigitalAnchor/Intereact'));
const FAQ = lazy(() => import('./DigitalAnchor/FAQ'));
const GlobalNotice = lazy(() => import('./GlobalNotice'));
const FunctionGuide = lazy(() => import('./FunctionGuide'));
const SigninGuide = lazy(() => import('./SigninGuide'));
const Learn = lazy(() => import('./Learn'));
const MobileIndex = lazy(() => import('./Mobile'));
const Agreement = lazy(() => import('./Agreement'));
const AnchorMakerAgreement = lazy(() => import('./AnchorMakerAgreement'));
const ExternalAuthPop = lazy(() => import('./ExternalAuthModal/authPop'));

const menuList = [
    {
        key: 'script',
        title: '直播间'
    },
    {
        key: 'character',
        title: '数字人'
    },
    {
        key: 'faq',
        title: '互动配置'
    },
    {
        key: 'ai-tools',
        title: 'AI工具',
        children: [
            {
                key: 'aiimg',
                title: 'AI生图'
            },
            {
                key: 'aiscripttool',
                title: 'AI脚本'
            }
        ]
    },
    {
        key: 'learn',
        title: '课程资源'
    },
    {
        key: 'externallive',
        title: '站外开播'
    }
];
// mis平台 通知管理(数据后端维护)
// 剧本实验协议通告 type = 6
// 通告 type = 4
const NOTICE_TYP = [4, 6];
const AGREEMENT_TYPE = 6;

// 协议签署状态 0:未签署，1：同意签署 2：拒绝签署
const AGREEMENT_STATUS = {
    unsigned: 0,
    signed: 1,
    reject: 2
};

let LoginPanel;

const initLoginPanel = () => {
    if (!window.passport) {
        setTimeout(initLoginPanel, 50);
        return;
    }

    LoginPanel = window.passport.pop.init({
        loginVersion: 'v4',
        apiOpt: {
            staticPage: 'https://huibo.baidu.com/',
            product: 'live', // 产品线标志，pp只是用于示例，请填写申请的tpl
            u: '/index.html#/script', // 登录成功跳转地址
            memberPass: true, // 记住登录状态，原isMen
            safeFlag: 0
        },
        cache: true, //  缓存
        forgetLink: 'https://passport.baidu.com/?getpass_index', // 忘记密码
        registerLink: 'https://passport.baidu.com/v2/?reg&tpl=&u=', // 注册链接
        tangram: true,
        onLoginSuccess: args => {
            webVisitLog('register');
            args.returnValue = false;
            window.location.href = '/index.html#/script';
            window.location.reload();
        }
    });
};

const initExernalAuth = async () => {
    try {
        await getAvailablePort();
        await getPluginVersion();
        await initPlugin();
    }
    catch (error) {
    }
};

function isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase()) || screenWidth < 768;
}

const Index = () => {
    const store = useStore();
    const taskStore = store.taskStore;
    const {scriptAuth, ernieAuth, rewriteAuth, hasTestLiveAuth, aigcImgAuth, waterMaskAuth, v3Auth, hasPushLiveAuth,
        mountAuth, isDhTemplateAuth, registCode, isAgreement, mediaAuth} = store;
    const pageHash = window.location.hash;
    const hashMenu = pageHash.match(/#\/(.*)/)[1];
    const [firstLoading, setFirstLoading] = useState(true);
    const [menu, setMenu] = useState(hashMenu); // 菜单key
    const [ernieFaqProgress, setErnieFaqProgress] = useState();
    const [ernieFaqTaskId, setErnieFaqTaskId] = useState();
    const [ernieFaqGoodsId, setErnieFaqGoodsId] = useState();
    const [userInfo, setUserInfo] = useState({});
    const [hasscrollY, setHasScrollY] = useState(window.scrollY > 0);
    const [selectList, setSelectList] = useState([]);
    const [headerTips, setHeaderTips] = useState();
    const [mediaModal, setMediaModal] = useState(false);
    const [showAgreementModal, setShowAgreementModal] = useState(false);
    const [isConfirmAgreement, setIsConfirmAgreement] = useState(false);
    const [consentModal, setConsentModal] = useState(false);
    const [agreementContent, setAgreementContent] = useState({});
    const [isShowHeaderTips, setIsShowHeaderTips] = useState(false);
    const [uploadProcess, setUploadProcess] = useState(0); // 上传进度
    const [showCreate, setShowCreate] = useState(false);
    const [roomInfo, setRoomInfo] = useState({});
    const [form] = Form.useForm();
    const [videoUrl, setVideoUrl] = useState('');
    // 数字人制作协议
    const [anchorMakerModal, setAnchorMakerModal] = useState(false);
    const [anchorMakerAgreement, setAnchorMakerAgreement] = useState(false);
    const {oneclicklive, registcode: registCodeFromUrl} = parseUrl(pageHash);

    const [faqVisible, setFaqVisible] = useState(!getStorage(FAQ_UPDATE_POPOVER));

    const [activeMenu, setActiveMenu] = useState({});

    const onFormVaulesChange = e => {
        setRoomInfo({
            ...roomInfo,
            ...e
        });
    };

    const handleSub = async () => {
        if (!videoUrl) {
            return;
        }
        await form.validateFields().then(async () => {
            const categoryList = [];
            for (let key in roomInfo) {
                if (key !== 'videoUrl' && key !== 'anchorName') {
                    if (roomInfo[key] instanceof Array) {
                        categoryList.push(...roomInfo[key]);
                    }
                    else {
                        categoryList.push(roomInfo[key]);
                    }
                }
            }
            const params = {
                upload_url: videoUrl,
                display_name: roomInfo.anchorName,
                category_list: categoryList.join('、')
            };
            const res = await saveMediaInfo(params);
            if (res.errno === 0) {
                message.success('保存成功');
                setVideoUrl('');
                setRoomInfo({});
                setShowCreate(false);
                setUploadProcess(0);
                setMediaModal(false);
            }
            else {
                message.error('保存失败');
            }
        }).catch(() => {});
    };

    const handleSelect = (value, length) => {
        if (value.length > length) {
            value.pop();
        }
    };

    const handleCancel = () => {
        setMediaModal(false);
    };

    const onUploadVideo = async options => {
        const {file} = options;

        setShowCreate(false);

        setUploadProcess(10);
        setTimeout(() => {
            updateVideo(file);
        }, 100);
    };

    const updateVideo = async (file) => {
        const res = await uploadMulti(file);

        if (res && res.url) {
            message.success('上传成功');
            setVideoUrl(res.url);
            setUploadProcess(100);
            setShowCreate(true);
        }
        else {
            message.warning('上传失败，请稍后重试');
            setUploadProcess(0);
        }
    };

    const mediaClick = () => {
        setMediaModal(true);
        form.setFieldsValue(roomInfo);
    };

    const setHashMenu = value => {
        if (value !== menu) {
            if (menu === 'aiimg') {
                Modal.confirm({
                    title: '确认离开AI生图页面吗？',
                    content: '离开当前页面后，你创作的AI商品图将不会保存，如有保存需求，请离开前将所需的图片导入到素材库',
                    onOk: () => {
                        window.location.hash = `/${value}`;
                    }
                });
            }
            else {
                // 退出登录的时候会等于 home，此时不需要跳转
                if (
                    (!store.mountAuth || !store.isDhTemplateAuth || (!store.registCode && !value.includes('oneclicklive')))
                    && value !== 'home' && value !== 'mobile' && value !== 'aiscripttool' && value !== 'agreement'
                ) {
                    const signinQuery = registCodeFromUrl ? `?oneclicklive=true&registcode=${registCodeFromUrl}` : '';
                    window.location.hash = `/signinguide${signinQuery}`;
                    return;
                }
                if (store.mountAuth && store.isDhTemplateAuth && store.registCode && !store.isAgreement
                    && value !== 'agreement') {
                    setShowAgreementModal(true);
                    return;
                }
                window.location.hash = `/${value}`;
                if (value === 'externallive') {
                    location.reload();
                }
            }

            if (value === 'aiimg') {
                aiimgClickEntryLog();
                efficiencyLog('AI_pic', 'start');
            }
        }
        else {
            ['home', 'mobile', 'signinguide'].indexOf(value) < 0 && location.reload();
        }
    };

    const handleLogout = () => {
        const url = `https://passport.baidu.com/?logout&u=${
            encodeURIComponent(window.location.href)}`;

        window.location.href = url;
    };

    const fetchUserInfo = async () => {
        const {errno, data} = await store.fetchUserInfo();

        setUserInfo(data);
        return +errno === 0 ? data : null;
    };

    const login = async () => {
        LoginPanel.show();
    };

    const fetchErnieFaqProgress = async () => {
        taskStore.fetchProgress();
    };

    // 获取公告协议内容
    const fetchAgreementContent = async () => {
        const res = await getAgreementContent().catch(() => {});

        if (res.errno === 0 && res.data) {
            setAgreementContent(res.data || null);
            setIsShowHeaderTips(!get(res.data, 'result', AGREEMENT_STATUS.unsigned));
        }
    };

    const fetchHeaderTips = async () => {
        const res = await getNoticeCarouselList().catch(() => {});

        if (res.errno === 0 && res.data && res.data.list) {
            setHeaderTips(res.data.list[0] || null);
            // 如果是 协议公告类型 则获取协议内容再决定是否展示公告 反之 直接展示公告
            if (res.data.list[0].type === AGREEMENT_TYPE) {
                fetchAgreementContent();
                return;
            }
            setIsShowHeaderTips(!!res.data.list[0]);
        }
    };

    useEffect(() => {
        headerTips && infoBannerLog('notice_show', {notice_id: headerTips.id});
    }, [headerTips]);

    const fetchRead = async id => {
        const {errno} = await readNotice({
            id: [id]
        });
    };

    const fetchPopTips = async () => {
        const lastPop = getStorage(NOTICE_POP_SHOW_DATE);
        const today = moment().format('YYYY-MM-DD');

        const showPopTips = list => {
            if (!list || !list.length) {
                return;
            }

            const item = list.pop();

            notification.open({
                className: 'huibo-pop-notice',
                message: item.title,
                // bca-disable-next-line
                description: <p dangerouslySetInnerHTML={{__html: item?.content?.replaceAll(/(https?:\/\/[^\s]+)/g, '<a href="$&" target="__blank">$&</a>')}}></p>,
                duration: null,
                onClose: () => {
                    showPopTips(list);
                    fetchRead(item.id);
                }
            });
        };

        if (!lastPop || lastPop !== today) {
            const res = await getNoticePopList().catch(() => {});

            if (res.errno === 0 && res?.data?.list?.length) {
                setStorage(NOTICE_POP_SHOW_DATE, today);
                showPopTips(res.data.list);
            }
        }
    };

    useEffect(() => {
        const aiQaProgress = taskStore.aiQA;
        if (JSON.stringify(aiQaProgress) === '{}') {
            setErnieFaqProgress(null);
            setErnieFaqTaskId();
        }
        else {
            setErnieFaqProgress(aiQaProgress.status);
            setErnieFaqTaskId(aiQaProgress.task_id);
            setErnieFaqGoodsId(aiQaProgress.question_type_id);
        }

    }, [taskStore.aiQA]);

    const fetchAuth = async () => {
        const preRes = await store.fetchPreCheckAuth();
        const res = await store.fetchAuth();
        if (res[11]) {
            await initExernalAuth();
            await store.fetchExternalLiveInfo();
        }
        if (!store.mountAuth || !store.isDhTemplateAuth || !store.registCode) {
            setFirstLoading(false);

            if (hashMenu && ['home', 'mobile', 'agreement', 'aiscripttool'].indexOf(hashMenu) < 0) {
                setHashMenu('signinguide');
            }

            return;
        }

        setFirstLoading(false);

        // 从中控台跳转过来的
        if (hashMenu && oneclicklive && registCodeFromUrl) {
            const res = await anchorMakerAgreementResult().catch(() => {});
            // 未签署协议才展示协议弹窗
            setAnchorMakerModal(res?.data?.result === 0);
        }

        if (!store.isAgreement && hashMenu !== 'agreement') {
            setShowAgreementModal(true);
            return;
        }

        if (!store.scriptAuth || !res) {
            if (isMobile()) {
                setHashMenu('mobile');
            }
            else {
                setHashMenu('home');
            }
        }
        else {
            webVisitLog('authority');
        }
    };

    const geSelectInfo = async () => {
        const res = await getMediaSelectInfo({attribution: 101});
        if (res.errno === 0 && res.data) {
            const selectListInfo = [];
            const dataList = res.data.list;
            for (let i = 0; i < dataList.length; i++) {
                const temp = dataList[i].children;
                selectListInfo[i] = {
                    id: dataList[i].id,
                    name: dataList[i].name,
                    maxSelect: dataList[i].select_maximum,
                    selectInfo: []
                };
                for (let j = 0; j < temp.length; j++) {
                    selectListInfo[i].selectInfo.push({
                        value: temp[j].name,
                        label: temp[j].name
                    });
                }
            };
            setSelectList(selectListInfo);
        }
    };

    const goLearn = () => {
        learnCenterLog('learning_center');
        setHashMenu('learn');
    };

    const init = async () => {
        taskStore.setInfos(QUERY_PROGRESS_TYPE.AI_QA);
        initLoginPanel();
        const userInfo = (await fetchUserInfo()) || {};
        if (!userInfo.display_name) {
            if (isMobile()) {
                setHashMenu('mobile');
            }
            else {
                setHashMenu('home');
            }
            setFirstLoading(false);
            return;
        }
        webVisitLog('register');// 登录用户访问慧播星
        await fetchAuth();
        fetchHeaderTips();
        fetchPopTips();
        fetchErnieFaqProgress();

        geSelectInfo();

        const pageHash = window.location.hash;

        const hashMenu = pageHash.match(/#\/(.*)/)[1];
        if (hashMenu !== menu) {
            setHashMenu(hashMenu);
        }
        if (hashMenu === 'aiimg') {
            efficiencyLog('AI_pic', 'start');
        }

        const onHashChange = () => {
            const pageHash = window.location.hash;
            const hashMenu = pageHash.match(/#\/(.*)/)[1];
            // 放置
            setMenu(hashMenu);
            taskStore.resetTask();// 切换路由，重置task
            taskStore.setInfos(QUERY_PROGRESS_TYPE.AI_QA);
        };

        window.addEventListener('hashchange', onHashChange);

        return () => {
            window.removeEventListener('hashchange', onHashChange);
        };
    };

    useInterval(() => {
        if (window.location.hash !== '#/externallivepage') {
            taskStore.fetchProgress();
        }
    }, taskStore.time);

    useEffect(() => {
        const scrollListener = () => {
            setHasScrollY(window.scrollY > 5);
        };
        document.addEventListener('scroll', scrollListener, false);

        return () => {
            document.removeEventListener('scroll', scrollListener, false);
        };
    }, []);

    // menu变化切换hash路由
    useEffect(() => {
        init();
        Spin.setDefaultIndicator(
            <div className="huibo-global-spin">
                <img className="huibo-global-spin-img" src={globalLoading} />
            </div>
        );
    }, []);

    const handleClickMenu = (menuKey) => {
        switch (menuKey) {
            case 'faq':
                productLibraryLog('tab', '1');
                break;
            case 'aiscripttool':
                aiScriptToolLog('fp_script', {
                    hbx_right: store.customerAcquisitionAuth ? '线索' : String((store.mountAuth && store.isDhTemplateAuth && store.registCode))
                });
                break;
            case 'script':
                scripListLog('script');
                break;
            case 'learn':
                learnCenterLog('learning_center');
                break;
            default:
                break;
        }

        setHashMenu(menuKey);
    };

    // 以下渲染相关
    const getMenu = () => {
        const hasLogin = userInfo?.display_name || userInfo.op_uc_id;
        return (
            <div className="row huibo-header-menu">
                {!hasLogin || !scriptAuth ? null : menuList.map(menuItem => {
                    let {children} = menuItem;

                    const isActive = menuItem.key === menu || children?.some(child => child.key === menu);

                    if (children?.length) {
                        const showTitle = isActive ? children.find(child => child.key === menu)?.title : menuItem.title;
                        // ai生图加权限
                        children = children.filter(childMenu => {
                            if (childMenu.key === 'aiimg') {
                                return aigcImgAuth;
                            }
                            return true;
                        });
                        return <Popover
                            key={menuItem.key}
                            overlayClassName='header-menu-popover'
                            content={
                                <div className="huibo-header-submenu">
                                    {children.map((child, index) => (
                                        <div
                                            key={index}
                                            className={cls('huibo-header-submenu-item', {
                                                active: child.key === menu
                                            })}
                                            onClick={() => {
                                                handleClickMenu(child.key);
                                            }}
                                        >
                                            {child.title}
                                        </div>
                                    ))}
                                </div>
                            }
                            onVisibleChange={e => {
                                setActiveMenu({
                                    ...activeMenu,
                                    [menuItem.key]: e
                                });
                            }}
                            placement='bottom'
                            getPopupContainer={triggerNode => triggerNode.parentNode}
                        >
                            <div
                                key={menuItem.key}
                                className={cls('huibo-header-menu-item', {
                                    active: isActive
                                })}
                            >
                                {showTitle}
                                <img
                                    className={cls({'force': activeMenu[menuItem.key]})}
                                    src={isActive ? iconArrActive : iconArrDefault}
                                    alt=""
                                />
                            </div>
                        </Popover>;
                    }

                    return <div
                        key={menuItem.key}
                        className={cls('huibo-header-menu-item', {
                            active: isActive,
                            noshow: menuItem.key === 'externallive' && !hasPushLiveAuth
                        })}
                        onClick={() => {
                            handleClickMenu(menuItem.key);
                        }}
                    >
                        {menuItem.title}
                        {menuItem.key === 'externallive' && menuItem.key === menu && store.externalLiveInfo.id
                            ? <img className='huibo-header-menu-item-icon' src={iconPlaying} />
                            : null
                        }
                    </div>;
                })}
            </div>
        );
    };

    const getContent = () => {
        const hasLogin = userInfo.display_name || userInfo.op_uc_id;
        return (
            <Switch>
                <Route path="/home" exact>
                    <Suspense fallback={<Spin className="loading-container" />}>
                        <WeirwoodErrorBoundary>
                            <Home
                                setHashMenu={setHashMenu}
                                userInfo={userInfo}
                                scriptAuth={scriptAuth}
                                mediaAuth={mediaAuth}
                                selectList={selectList}
                                login={login}
                            />
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/signinguide" exact>
                    <Suspense fallback={<Spin className="loading-container" />}>
                        <WeirwoodErrorBoundary>
                            {mountAuth && isDhTemplateAuth && registCode && hasLogin && scriptAuth
                                ? <DigitalHome
                                    setHashMenu={setHashMenu}
                                    rewriteAuth={rewriteAuth}
                                    hasTestLiveAuth={hasTestLiveAuth}
                                    hasErnieAuth={ernieAuth}
                                    // setErnieAuth={setErnieAuth}
                                    userInfo={userInfo}
                                    ernieFaqTaskId={ernieFaqTaskId}
                                    ernieFaqProgress={ernieFaqProgress}
                                    fetchErnieFaqProgress={fetchErnieFaqProgress}
                                    waterMaskAuth={waterMaskAuth}
                                    v3Auth={v3Auth}
                                    hasPushLiveAuth={hasPushLiveAuth}
                                />
                                : <SigninGuide
                                    setHashMenu={setHashMenu}
                                    init={init}
                                    userInfo={userInfo}
                                    login={login}
                                />}
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/script" exact>
                    <Suspense fallback={<Spin className="loading-container" />}>
                        <WeirwoodErrorBoundary>
                            {hasLogin && scriptAuth ? (
                                <DigitalHome
                                    setHashMenu={setHashMenu}
                                    rewriteAuth={rewriteAuth}
                                    hasTestLiveAuth={hasTestLiveAuth}
                                    hasErnieAuth={ernieAuth}
                                    // setErnieAuth={setErnieAuth}
                                    userInfo={userInfo}
                                    ernieFaqTaskId={ernieFaqTaskId}
                                    ernieFaqProgress={ernieFaqProgress}
                                    fetchErnieFaqProgress={fetchErnieFaqProgress}
                                    waterMaskAuth={waterMaskAuth}
                                    v3Auth={v3Auth}
                                    hasPushLiveAuth={hasPushLiveAuth}
                                />
                            ) : null}
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/editor" exact>
                    <Suspense fallback={<Spin className="loading-container" />}>
                        <WeirwoodErrorBoundary>
                            {hasLogin && scriptAuth ? (
                                <DigitalHome
                                    setHashMenu={setHashMenu}
                                    rewriteAuth={rewriteAuth}
                                    hasTestLiveAuth={hasTestLiveAuth}
                                    hasErnieAuth={ernieAuth}
                                    // setErnieAuth={setErnieAuth}
                                    userInfo={userInfo}
                                    waterMaskAuth={waterMaskAuth}
                                    v3Auth={v3Auth}
                                    aigcImgAuth={aigcImgAuth}
                                    editor
                                />
                            ) : null}
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/character" exact>
                    <Suspense fallback={<Spin className="loading-container" />}>
                        <WeirwoodErrorBoundary>
                            {hasLogin && scriptAuth ? (
                                <DigitalCharacter
                                    setHashMenu={setHashMenu}
                                    ernieFaqTaskId={ernieFaqTaskId}
                                    ernieFaqProgress={ernieFaqProgress}
                                    fetchErnieFaqProgress={fetchErnieFaqProgress}
                                    v3Auth={v3Auth}
                                />
                            ) : null}
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/faq" exact>
                    <Suspense fallback={<Spin className="loading-container" />}>
                        <WeirwoodErrorBoundary>
                            {hasLogin && scriptAuth ? (
                                <FAQ
                                    ernieFaqProgress={ernieFaqProgress}
                                    setErnieFaqProgress={setErnieFaqProgress}
                                    fetchErnieFaqProgress={fetchErnieFaqProgress}
                                    ernieFaqTaskId={ernieFaqTaskId}
                                    setErnieFaqTaskId={setErnieFaqTaskId}
                                    ernieFaqGoodsId={ernieFaqGoodsId}
                                />
                            ) : null}
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/interact" exact>
                    <Suspense fallback={<Spin className="loading-container" />}>
                        <WeirwoodErrorBoundary>
                            {hasLogin && scriptAuth ? (
                                <Interact
                                    setHashMenu={setHashMenu}
                                />
                            ) : null}
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>

                <Route path="/aiimg" exact>
                    <WeirwoodErrorBoundary>
                        {hasLogin && scriptAuth && aigcImgAuth ? (
                            <AIGCImage
                                setHashMenu={setHashMenu}
                            />
                        ) : null}
                    </WeirwoodErrorBoundary>
                </Route>
                <Route path="/aiscripttool" exact>
                    <WeirwoodErrorBoundary>
                        {hasLogin && (
                            <AIGCScriptTool headerTips={isShowHeaderTips} />
                        ) }
                    </WeirwoodErrorBoundary>
                </Route>
                <Route path="/externallive" exact>
                    {hasLogin && (
                        <ExternalLive headerTips={isShowHeaderTips} />
                    ) }
                </Route>
                <Route path="/externallivepage" exact>
                    {hasLogin && (
                        <ExternalLivePage />
                    )}
                </Route>
                <Route path="/learn" exact>
                    <Suspense fallback={null}>
                        <WeirwoodErrorBoundary>
                            <Learn headerTips={isShowHeaderTips} />
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/agreement" exact>
                    <Suspense fallback={null}>
                        <WeirwoodErrorBoundary>
                            <Agreement />
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/anchormakeragreement" exact>
                    <Suspense fallback={null}>
                        <WeirwoodErrorBoundary>
                            <AnchorMakerAgreement />
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Route path="/mobile" exact>
                    <Suspense fallback={null}>
                        <WeirwoodErrorBoundary>
                            <MobileIndex />
                        </WeirwoodErrorBoundary>
                    </Suspense>
                </Route>
                <Redirect to={isMobile() ? '/mobile' : '/home'} />
            </Switch>
        );
    };

    const getHelpContent = () => {
        return (
            <div className="huibo-header-help-popover-content">
                <a href="https://yingxiao.baidu.com/course/outside/detail?detailId=6827" target="_blank" rel="noreferrer">操作手册</a>
                <a href="https://yingxiao.baidu.com/course/outside/detail?detailId=6818" target="_blank" rel="noreferrer">营销通案</a>
                <a href="https://yingxiao.baidu.com/course/outside/detail?detailId=6828" target="_blank" rel="noreferrer">成功案例</a>
            </div>
        );
    };

    if (firstLoading) {
        return <Spin className="loading-container" />;
    }
    const onClickLogo = () => {
        if (scriptAuth) {
            setHashMenu('script');
        }
        else {
            setHashMenu('home');
        }
    };

    const onClickHeaderTips = () => {
        infoBannerLog('notice_click', {notice_id: headerTips.id});
        if (headerTips.type === AGREEMENT_TYPE) {
            get(agreementContent, 'content', '') ? setConsentModal(true) : message.error('未获取到相关协议内容');
            return;
        }
        if (headerTips.jump_url) {
            window.open(headerTips.jump_url, '_blank');
        }
    };

    const onCloseHeaderTips = e => {
        e.stopPropagation();
        setIsShowHeaderTips(false);
    };

    const handleCancelConsent = () => {
        setConsentModal(false);
    };

    const handleConsent = async (type) => {
        const params = {
            agreement_id: get(agreementContent, 'id', 0),
            action: type === 'ok' ? AGREEMENT_STATUS.signed : AGREEMENT_STATUS.reject
        };
        const res = await agreementAction(params).catch(() => {});

        if (res.errno === 0) {
            setConsentModal(false);
            setIsShowHeaderTips(false);
            if (type === 'ok') {
                message.success('欢迎您参加实验');
            }
            else {
                message.open({content: '感谢您的反馈', icon: null});
            }
        }
        else {
            message.error(res.errmsg);
        }
    };

    const handleAgree = async () => {
        if (!isConfirmAgreement) {
            message.info('请阅读并接受《慧播星服务协议》');
            return;
        }

        const res = await confirmAgreement({plat_agreement: 1}).catch(() => {});

        if (res?.errno === 0) {
            setTimeout(() => {
                window.location.reload();
            }, 300);
        }
        else {
            message.error(res?.errmsg || '网络异常，请稍后重试');
        }
    };

    const handleAnchorMakerAgree = async () => {
        if (!anchorMakerAgreement) {
            message.info('请阅读并接受《慧播星数字人制作协议》');
            return;
        }

        // 1-同意 2-拒绝
        const res = await confirmAnchorMakerAgreement({action: 1}).catch(() => {});
        if (res?.errno === 0) {
            setTimeout(() => {
                window.location.reload();
            }, 300);
        }
        else {
            message.error(res?.errmsg || '网络异常，请稍后重试');
        }
    };

    return (
        <div className={`huibo-container ${isShowHeaderTips ? 'hasTips' : ''}`}>
            {(hashMenu !== 'mobile' && hashMenu !== 'editor' && hashMenu !== 'externallivepage') && (
                <React.Fragment>
                    {isShowHeaderTips && (
                        <div className="row huibo-header-tips" onClick={onClickHeaderTips}>
                            <div>{headerTips.content}</div>
                            {includes(NOTICE_TYP, headerTips.type) && <div className="row huibo-header-tips-jump">前往了解</div>}
                            <img className="huibo-header-tips-close" src={iconClose} alt="" onClick={onCloseHeaderTips} />
                        </div>
                    )}
                    <div className={cls('row huibo-header', {
                        home: hashMenu === 'home',
                        scrolled: hasscrollY,
                        hasTips: isShowHeaderTips
                    })}
                    >
                        <div className="row huibo-header-content">
                            <img className="huibo-header-logo" src={logo} onClick={onClickLogo} />
                            {(hashMenu !== 'agreement')
                                ? <React.Fragment>
                                    {getMenu()}
                                    <div className="row">
                                        {mediaAuth && <div
                                            className="huibo-header-upload"
                                            onClick={() => {
                                                mediaClick();
                                            }}
                                        >我是供应商</div>}
                                        {/* <Popover
                                            trigger="click"
                                            placement='topLeft'
                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                            overlayClassName="digital-global-help-popover"
                                            content={getHelpContent()}
                                        > */}
                                        <FunctionGuide setHashMenu={setHashMenu} />
                                        {/* <img className="huibo-header-help" src={iconSchool} onClick={goLearn} /> */}
                                        {/* </Popover> */}
                                        {userInfo && (userInfo.display_name || userInfo.op_uc_id) ? <GlobalNotice /> : null}
                                        {hasPushLiveAuth && <ExternalAuthPop />}
                                        {userInfo && (userInfo.display_name || userInfo.op_uc_id) ? (
                                            <Popover
                                                trigger="hover"
                                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                                content={(
                                                    <div className="logout-area" onClick={handleLogout}>
                                                        <span>退出登录</span>
                                                    </div>
                                                )}
                                            >
                                                <div className="row huibo-header-user-info">
                                                    <img className="huibo-header-user-info-avatar" src={userInfo.avatar} />
                                                    <p>{userInfo.display_name}</p>
                                                </div>
                                            </Popover>
                                        ) : <div onClick={login}>登录/注册</div>}
                                    </div>
                                </React.Fragment> : null}
                        </div>
                    </div>
                </React.Fragment>
            )}
            {getContent()}
            {
                mediaModal && <Modal
                    title="上传音频"
                    visible
                    maskClosable={false}
                    destroyOnClose
                    onCancel={handleCancel}
                    footer={null}
                    className="huibo-home-media-modal"
                >
                    <MediaModaContent
                        uploadProcess={uploadProcess}
                        setUploadProcess={setUploadProcess}
                        showCreate={showCreate}
                        roomInfo={setRoomInfo}
                        selectList={selectList}
                        setMediaModal={setMediaModal}
                        form={form}
                        onFormVaulesChange={onFormVaulesChange}
                        handleSub={handleSub}
                        onUploadVideo={onUploadVideo}
                        handleCancel={handleCancel}
                        handleSelect={handleSelect}
                    />
                </Modal>
            }
            <Modal
                visible={consentModal}
                maskClosable={false}
                onCancel={handleCancelConsent}
                className="huibo-consent-modal"
                closeIcon={<img src={iconClose2} className="huibo-consent-modal-icon" />}
                width='56%'
                footer={
                    <div>
                        <Button onClick={partial(handleConsent, 'cancel')}>拒绝</Button>
                        <Button className='huibo-consent-modal-btn-primary' onClick={partial(handleConsent, 'ok')}>同意</Button>
                    </div>
                }
            >
                <div
                    dangerouslySetInnerHTML={{__html: agreementContent.content}} // bca-disable-line
                />
            </Modal>

            <Modal
                visible={showAgreementModal}
                maskClosable={false}
                closeIcon={<div />}
                className="huibo-agreement-modal"
                width="376px"
                footer={
                    <div>
                        <Button className='huibo-agreement-btn' onClick={partial(handleAgree, 'ok')}>确认</Button>
                    </div>
                }
            >
                <div>
                    <div>为保证您的权益并正常使用慧播星平台功能，请您签署慧播星用户协议。</div>
                    <div
                        className={`row huibo-agreement-modal-radio ${isConfirmAgreement ? 'active' : ''}`}
                        onClick={() => setIsConfirmAgreement(true)}
                    >
                        <div className="agreement-radio"><div className="agreement-radio-inner"></div></div>
                        <div>阅读并接受
                            <a
                                className="agreement-link"
                                href={`${location.protocol}//${location.host}/index.html#/agreement`}
                                target='__blank'
                            >
                                《慧播星用户协议》
                            </a>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                visible={anchorMakerModal}
                maskClosable={false}
                closeIcon={<div />}
                className="huibo-agreement-modal"
                width="376px"
                footer={
                    <div>
                        <Button className='huibo-agreement-btn' onClick={handleAnchorMakerAgree}>确认</Button>
                    </div>
                }
            >
                <div>
                    <div>为保证您的权益并正常使用慧播星平台功能，请您签署慧慧播星数字人制作协议。</div>
                    <div
                        className={`row huibo-agreement-modal-radio ${anchorMakerAgreement ? 'active' : ''}`}
                        onClick={() => setAnchorMakerAgreement(true)}
                    >
                        <div className="agreement-radio"><div className="agreement-radio-inner"></div></div>
                        <div>阅读并接受
                            <a
                                className="agreement-link"
                                href={`${location.protocol}//${location.host}/index.html#/anchormakeragreement`}
                                target='__blank'
                            >
                                《慧播星数字人制作协议》
                            </a>
                        </div>
                    </div>
                </div>
            </Modal>
            {store.externalStore.showExternalModal && <ExternalAuthModal />}
        </div>
    );
};

export default observer(Index);
